<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="subtract">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M3.3999 12.0002C3.3999 11.7241 3.62376 11.5002 3.8999 11.5002H20.8999C21.176 11.5002 21.3999 11.7241 21.3999 12.0002C21.3999 12.2764 21.176 12.5002 20.8999 12.5002H3.8999C3.62376 12.5002 3.3999 12.2764 3.3999 12.0002Z" fill="#212328"/>
</g>
</svg>
